import { Component, ElementRef, Input, OnChanges, OnDestroy, OnInit, Renderer2, ViewChild, AfterViewInit } from '@angular/core';

import { NgRedux, select } from '@angular-redux/store';
import { Subscription } from 'rxjs';

import { AppState } from '../../../../interfaces/store.interface';
import { SalesArea, SalesFilterOptions } from '../../../../interfaces/sales.interface';
import { GoogleAnalyticsService } from '../../../shared/services/google-analytics/google-analytics.service';

import { SalesActionsService } from '../../../store/actions/sales.actions';
import { UiActionsService } from '../../../store/actions/ui.actions';

import { ISellingItemStore, ISellingItem } from '../../../../interfaces/SellingItem.interface';
import { OrderActionsService } from '../../../store/actions/order.actions';
import { IOrderStore } from '../../../../interfaces/order/OrderStore.interface';

@Component({
    selector: 'app-listing-thumbs',
    templateUrl: './listing-thumbs.component.html',
    styleUrls: ['./listing-thumbs.component.scss']
})
export class ListingThumbsComponent implements OnChanges, OnInit, AfterViewInit, OnDestroy {

    @ViewChild('container', { static: false }) container: ElementRef;

    @Input() vehicleId: string;
    @Input() orderId: string;
    @Input() bundleIndex: number;
    @Input() context: 'orders';

    vehicle: ISellingItemStore;
    props: ISellingItem | any;

    position: string;

    nextDisabled: boolean;
    previousDisabled: boolean;

    private indexSubscription = Subscription.EMPTY;
    private vehicleSubscription = Subscription.EMPTY;

    private thumbsCount: number;
    private thumbsWidth: number;

    private index: number = 0;
    private maxIndex: number;

    private thumbWidth = 156;
    private groupSize = 3;
    private groupWidth = this.thumbWidth * this.groupSize;

    constructor(
        private ngRedux: NgRedux<AppState>,
        private salesActions: SalesActionsService,
        private orderActions: OrderActionsService,
        private uiActions: UiActionsService,
        private renderer: Renderer2,
        private googleAnalytics: GoogleAnalyticsService
    ) { }

    ngOnInit() {

        if (this.context !== 'orders') {
            this.indexSubscription = this.ngRedux.select<number>(['sales', 'selected', 'thumbsIndex'])
                .subscribe((index: number) => {

                    this.index = index;

                    this.indexChanged();

                });
        }

    }

    ngAfterViewInit(): void {

    }

    ngOnChanges() {
        this.getVehicle(this.vehicleId);
    }

    ngOnDestroy() {
        this.indexSubscription.unsubscribe();
        this.vehicleSubscription.unsubscribe();
    }

    next() {
        if (!this.nextDisabled) {
            this.change(1);
        }
    }

    previous() {
        if (!this.previousDisabled) {
            this.change(-1);
        }
    }

    openGallery(index: number) {
        this.uiActions.setGalleryImages({ images: this.props._images });
        this.uiActions.setGalleryIndex({ index });
        this.uiActions.openGallery();

        // tell Google Analytics
        this.googleAnalytics.sendEvent({
            category: 'Button',
            label: 'Car gallery: ' + this.vehicle.id + ' - ' + index
        });

    }

    private change(direction: 0 | 1 | -1) {

        // dispatch our action
        if (this.context === 'orders') {
            this.index += direction;
            this.indexChanged();
        } else {
            this.salesActions.setThumbsIndex(this.index + direction);
        }

    }

    private indexChanged() {
        // disable / enable controls
        this.nextDisabled = this.index === this.maxIndex;
        this.previousDisabled = this.index === 0;

        // set the style
        const style = 'translate3d(' + (0 - (this.groupWidth * this.index)) + 'px, 0, 0)';

        if (this.container) {
            this.renderer.setStyle(this.container.nativeElement, 'transform', style);
        }
    }

    private setupGallery() {

        this.thumbsCount = this.props ? this.props._thumbnails.length : 0;
        // calc values
        this.thumbsWidth = this.thumbsCount * this.thumbWidth;
        this.maxIndex = Math.floor(this.thumbsCount / this.groupSize);
        // setup
        this.change(0);
    }

    private getVehicle(vehicleId: string) {
        this.vehicleSubscription.unsubscribe();

        if (vehicleId) {

            if (this.context !== 'orders') {
                this.retrieveDataFromSellingItems(vehicleId);
            } else {
                this.retrieveDataFromOrders(vehicleId, this.orderId);
            }

        }
    }

    private retrieveDataFromSellingItems(vehicleId: string) {
        this.vehicleSubscription = this.ngRedux.select(['entities', 'sellingItems', vehicleId])
            .subscribe((vehicle: ISellingItemStore) => {
                this.vehicle = vehicle;
                //                    this.thumbsCount = vehicle ? vehicle.props._thumbnails.length : 0;
                //                    // calc values
                //                    this.thumbsWidth = this.thumbsCount * this.thumbWidth;
                //                    this.maxIndex = Math.floor(this.thumbsCount / this.groupSize);
                //                    // setup
                //                    this.change(0);

                this.afterDataRetrieval();
            });
    }

    private retrieveDataFromOrders(vehicleId: string, orderId: string) {
        this.vehicleSubscription = this.ngRedux.select(['entities', 'orders', orderId])
            .subscribe((order: IOrderStore) => {
                const si = [...order.props.items, ...order.props.deletedItems].find(sellingItem => {
                    return sellingItem.id === vehicleId;
                });
                if (!si) { return; }
                this.vehicle = {
                    id: si.id,
                    props: si
                };

                this.afterDataRetrieval();

            });
    }

    private afterDataRetrieval() {

        this.props = {
            _images: [],
            _thumbnails: [],
        };

        const v = this.vehicle.props._bundle ?
            this.vehicle.props.vehicles[this.bundleIndex] :
            this.vehicle.props.vehicles[0];
        this.props._images = v.media['images'];
        this.props._thumbnails = v.media['thumbs'];
        // v.media.map((media: string) => {
        //    this.props._images.push(`${environment.api.url}/vehicles/${v.id}/640/480/${media}`);
        //     this.props._thumbnails.push(`${environment.api.url}/vehicles/${v.id}/110/110/${media}`);
        // });

        this.index = 0;
        this.setupGallery();
    }

}
